export default __webpack_public_path__ + "static/media/img_guide_Mobile.07df1b78.png";